import React from 'react';
import { useSelector } from "react-redux";
import { InfoMode as InfoModeSwitch } from '../../../../Operation/InfoMode';
import Site from "../../../../../pages/PlanOperationPage/Popup/Site";
import { getTimeByOpMode } from "../../../../../pages/PlanOperationPage/util/function_operation/constants";
import { datetime } from "../../../../../util/library/datetime";
import { selectOpMode, selectTenantId } from "../../../../../util/store/selectors";
import { OP_STATUS, OPERATION_TYPE } from "../../../../../util/varibles/constants";
import { IHarvest2, IOperation2, IPropsChildren, IService2, ITransport2, ITreatment2, TOperation2 } from "../../../../../util/varibles/interface";
import { openPopup } from "../../../_components/WrapperPopup";
import { usePopupOpInfo } from '../../PopupOpInfoContext';
import Note from "../Note";

interface IProps extends IPropsChildren {
    isEdit: boolean
    data: Omit<IOperation2, "operation"> & {
        operation: TOperation2 &
        Partial<
            Pick<IHarvest2, "site_id" | "site_name" | "sub_operations"> &
            Pick<ITreatment2, "site_id" | "site_name" | "sub_operations"> &
            Pick<ITransport2, "source_id" | "source_name"> &
            Pick<IService2, "sub_operations">
        >
    }

    handleUpdateNote(note: string): void
}

const BoxOpInfo: React.FC<IProps> = (props) => {
    const opMode = useSelector(selectOpMode);
    const userTenantId = useSelector(selectTenantId);
    const [infoMode, setPopupInfo] = usePopupOpInfo(state => state.infoMode);
    const { isEdit, handleUpdateNote } = props;
    const {
        note = '',
        status,
        tenant_id,
        site_id,
        source_id,
        site_name,
        source_name,
        sub_operations
    } = props.data.operation;
    const showInfoMode = props.data.operation.operation_type === OPERATION_TYPE.HARVEST
        || props.data.operation.operation_type === OPERATION_TYPE.TREATMENT;
    const id = site_id || source_id || "";
    const isAnalysis = status !== OP_STATUS.CANCELED && id && tenant_id === userTenantId

    const openSite = () => {
        const start = getTimeByOpMode[opMode](props.data.activity_log[0])
        const el = openPopup(<Site
            site={{ id, name: site_name || source_name || "" }}
            unitId={sub_operations?.[0]?.id}
            year={datetime(start).year}
            onClose={() => el.remove()}
        />)
    }

    return <div className='mt-10 text-[15px]'>
        <div className='mb-10 flex items-center justify-between gap-4'>
            <div className='font-w4'>Operation info. {isAnalysis &&
                <span className='link ml-2' onClick={openSite}>Analytics</span>}
            </div>
            {showInfoMode && <InfoModeSwitch
                value={infoMode}
                onChange={(value) => setPopupInfo({ infoMode: value })}
            />}
        </div>
        {props.children}
        {(note || '').length > 0 && <Note {...{ isEdit, note, handleUpdate: handleUpdateNote }} />}
    </div>;
};

export default BoxOpInfo;
